import { Button, Modal } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CallAPI from "../../utility/functions/getData";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../utility/Redux/security";
import {
  selectCompanyAddress,
  selectDefultProfileSetting,
  selectPrefix,
  selectUserName,
  selectWidth,
} from "../../utility/Redux/profile";
import moment from "moment";
import NumberToWords3 from "../../utility/component/numberToFormat";
import {
  FormatNumber,
  FormatNumber2,
} from "../../utility/functions/formatNumber";

import ReactToPrint, { useReactToPrint } from "react-to-print";
import "../../styles/print.css";
import { FaWhatsapp } from "react-icons/fa";
import { TiArrowBackOutline, TiMessage } from "react-icons/ti";
import { BackButton, PrintButton } from "../../utility/component/buttons";

const VoucherPrint = ({
  status,
  paymodeSummary,
  ToDate,
  fromDate,
  onClose,
}) => {
  const company = useSelector(selectCompanyAddress);
  const userName = useSelector(selectUserName);
  const [amt, setAmt] = useState(0);
  const width = useSelector(selectWidth);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "500px",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "white",
  };

  const [voucherDetails, setVoucherDetails] = useState("");

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    pageStyle: `
        @page {
          size: portrait;
        }
      `,
    content: () => printRef.current,
  });
  const totalAmount = paymodeSummary[0]
    ? paymodeSummary[0].BTC_AMOUNT +
      paymodeSummary[0].CARD_AMOUNT +
      paymodeSummary[0].CASH_AMOUNT +
      paymodeSummary[0].E_AMOUNT +
      paymodeSummary[0].LOYALTY_DISCOUNT
    : 0;
  return (
    <Modal
      open={status}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div style={style} className="flex ">
        <div
          style={{
            height: `calc(100% - ${width > 767 ? 0 : 50}px)`,
          }}
          ref={printRef}
          id={"print-component"}
          className="w-[350px] p-2 text-sm"
        >
          <div className=" w-full border border-black ">
            <div className="w-full py-2 pt-3 font-semibold">
              <div className="justify-center flex w-full ">
                {company.companyName}
              </div>
              <div className="justify-center flex w-full text-center">
                {company.address}
              </div>
              <div className="justify-center flex w-full text-center">
                {company.city}, {company.state}{" "}
                {company.mobile && `, ${company.mobile}`}{" "}
                {company.website && `, ${company.website}`}
              </div>
            </div>
            <div className="flex w-full justify-center  border-t-black border-t p-2">
              <div className="flex">
                <div>{voucherDetails.VOUCHER_TYPE}</div>
                <div className="ml-2">Payment Mode Wise Sale Summary</div>
              </div>
            </div>

            <div className="flex w-full justify-center  border-t-black border-t p-2">
              <div className="flex">
                <div>Date :</div>
                <div className="ml-2">
                  {moment(fromDate).format("DD/MM/YYYY")}
                </div>
              </div>

              <div className="flex">
                <div className="ml-1">
                  - {moment(ToDate).format("DD/MM/YYYY")}
                </div>
              </div>
            </div>

            <div className="w-full   border-t-black border-t">
              {paymodeSummary.map((p) => {
                return (
                  <div>
                    <div
                      style={{
                        borderBottom: "1px dotted gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        Cash Amount
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(p?.CASH_AMOUNT)}
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px dotted gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        Card Amount
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(p?.CARD_AMOUNT)}
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px dotted gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        BTC Amount
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(p?.BTC_AMOUNT)}
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px dotted gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        E Amount
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(p?.E_AMOUNT)}
                      </div>
                    </div>

                    <div
                      style={{
                        borderBottom: "1px solid gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        Loyality Discount
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(p?.LOYALTY_DISCOUNT)}
                      </div>
                    </div>
                    <div
                      style={{
                        borderBottom: "1px solid gray",
                      }}
                      className="grid grid-cols-2 w-full "
                    >
                      <div
                        style={{
                          borderRight: "1px dotted gray",
                        }}
                        className=" p-1 font-semibold"
                      >
                        Total
                      </div>
                      <div className=" p-1 text-right">
                        {FormatNumber(totalAmount)}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className=" print:hidden grid grid-cols-1  justify-center">
            <button
              onClick={() => {
                onClose();
              }}
              className="bg-[#c1c1c1] mb-2 mt-4 text-black p-2 rounded-sm"
            >
              Back
            </button>
            <button
              onClick={handlePrint}
              className="bg-[#93c5fd] text-black p-2 rounded-sm"
            >
              Print
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VoucherPrint;
